export const HistoryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M7.33333 3.85547V2.1888C7.33333 1.72857 7.70643 1.35547 8.16667 1.35547H12.8215C13.0425 1.35547 13.2545 1.44327 13.4107 1.59955L16.2559 4.44472C16.4122 4.601 16.5 4.81297 16.5 5.03398V13.0221C16.5 13.4824 16.1269 13.8555 15.6667 13.8555L10.6667 13.8555M10.6667 8.02213L7.33333 8.02213C6.8731 8.02213 6.5 7.64904 6.5 7.1888V3.85547M16.5 5.52213L13.1667 5.52213C12.7064 5.52213 12.3333 5.14904 12.3333 4.6888V1.35547M2.33333 16.3555L9.83334 16.3555C10.2936 16.3555 10.6667 15.9824 10.6667 15.5221V7.53398C10.6667 7.31297 10.5789 7.101 10.4226 6.94472L7.57741 4.09955C7.42113 3.94327 7.20917 3.85547 6.98816 3.85547L2.33333 3.85547C1.8731 3.85547 1.5 4.22857 1.5 4.6888L1.5 15.5221C1.5 15.9824 1.8731 16.3555 2.33333 16.3555Z"
                stroke="#040404"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
